// Navigation Configuration
export const NAV_LINKS = [
  { id: "HOME", name: "Home", href: "/" },
  { id: "PORTFOLIO", name: "Portfolio", href: "/portfolio" },
  { id: "CONTACT", name: "Contact", href: "/contact" },
] as const;

// API Endpoints
export const API_ENDPOINTS = {
  ME: "/api/me",
  WORK_EXPERIENCE: "/api/work-experience",
  GITHUB_REPOS: "/api/github-repos",
  SEND_EMAIL: "/api/send-email",
} as const;

// Carousel Configuration
export const CAROUSEL_CONFIG = {
  LANGUAGES_DELAY: 3000,
  FRAMEWORKS_DELAY: 2000,
  TOOLS_DELAY: 2500,
  SKILL_IMAGE_SIZE: 80,
  MAX_VISIBLE_TOPICS: 5,
} as const;

// Form Configuration
export const FORM_CONFIG = {
  SUCCESS_TIMEOUT: 5000,
  SKILL_IMAGE_PATH: "/skills",
} as const;

// API Cache Configuration
export const CACHE_CONFIG = {
  GITHUB_REPOS: 3600, // 1 hour in seconds
} as const;

// Form Messages
export const FORM_MESSAGES = {
  NAME_REQUIRED: "Name is required",
  NAME_MIN: "Name must be at least 2 characters",
  EMAIL_REQUIRED: "Email is required",
  EMAIL_INVALID: "Please enter a valid email",
  SUBJECT_REQUIRED: "Subject is required",
  SUBJECT_MIN: "Subject must be at least 5 characters",
  MESSAGE_REQUIRED: "Message is required",
  MESSAGE_MIN: "Message must be at least 10 characters",
  SUBMIT_SUCCESS: "Message sent successfully! I'll get back to you soon.",
  SUBMIT_LOADING: "Sending...",
  SUBMIT_BUTTON: "Send Message",
  LOADING_PROFILE: "Loading profile...",
  FAILED_LOAD_PROFILE: "Failed to load profile.",
  PROFILE_LOAD_ERROR: "Please try refreshing the page.",
} as const;

// Page Titles and Descriptions
export const PAGE_CONTENT = {
  HOME: {
    ABOUT_TITLE: "About Me",
    ABOUT_TEXT:
      "I'm always looking for ways to grow, improve my skills, and learn new things. I enjoy solving problems, collaborating with others, and tackling challenges with determination. No matter the task, I'm committed to giving my best and seeing every project through to success.",
    SKILLS_TITLE: "Skills Inventory",
    LANGUAGES_TITLE: "Programming Languages",
    FRAMEWORKS_TITLE: "Frameworks & Libraries",
    TOOLS_TITLE: "Tools",
    EDUCATION_TITLE: "Education",
  },
  CONTACT: {
    TITLE: "Get in Touch",
    DESCRIPTION: "I'd love to hear from you. Send me a message and I'll respond as soon as possible.",
    INFO_TITLE: "Contact Information",
    FORM_TITLE: "Send a Message",
    CONTACT_DETAILS: {
      NAME: "Name",
      PHONE: "Phone",
      EMAIL: "Email",
      LINKEDIN: "LinkedIn",
      ADDRESS: "Address",
    },
  },
  PORTFOLIO: {
    TITLE: "My Portfolio",
    DESCRIPTION: "Explore my professional experience and open-source projects.",
    GITHUB_TAB: "GitHub Projects",
    EXPERIENCE_TAB: "Work Experience",
    GITHUB_ERROR: "Failed to load GitHub repositories.",
    EXPERIENCE_ERROR: "Failed to load portfolio.",
    NO_REPOS: "No repositories found.",
  },
} as const;

// GitHub Repository Card Configuration
export const GITHUB_CONFIG = {
  ANIMATION_DELAY: 30, // milliseconds between each card
  REPOS_PER_PAGE: 100,
  SORT_BY: "updated",
  MIN_VISIBLE_TOPICS: 0,
  MAX_VISIBLE_TOPICS_CARD: 5,
} as const;

// Skills Section Configuration
export const SKILLS_CONFIG = {
  GRID_COLS: "grid-cols-1 md:grid-cols-2",
  CAROUSEL_MAX_WIDTH: "max-w-md",
  IMAGE_WIDTH: 80,
  IMAGE_HEIGHT: 80,
} as const;

// Education Data
export const EDUCATION_DATA = [
  {
    school: "Suansunandha Rajabhat University",
    detail: "Faculty of Industrial Technology | Computer Engineering",
  },
  {
    school: "Panyaworakun School",
    detail: "Science-Math Program",
  },
] as const;

// Email Configuration
export const EMAIL_CONFIG = {
  FROM_DOMAIN: "onboarding@resend.dev",
  REPLY_TO_FIELD: "reply_to",
} as const;
